import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { open_api_with_cookies } from "../../Utils/network";
import LoadingOverlay from "../../components/Loading/LoadingOverlay";
import useAuth from "../../Hooks/useAuth";

const TokenLoginPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const next = searchParams.get("next") || "/dashboard";
  const [isLoading, setIsLoading] = useState(true);
  const { setIsAuthenticated, checkAuth } = useAuth();

  useEffect(() => {
    const loginViaToken = async () => {
      if (!token) {
        console.error("No token provided");
        navigate("/login?error=missing_token");
        return;
      }

      try {
        setIsLoading(true);

        const response = await open_api_with_cookies.get(
          `auth/token-login/${token}/`,
          {
            params: { next },
          }
        );

        if (response.status === 200) {
          // Update authentication state - checkAuth will handle setting cookies
          await checkAuth(); // Refresh auth state and set cookies
          setIsAuthenticated(true);

          // Check if the response indicates a redirect
          if (response.data?.redirect_url) {
            window.location.href = response.data.redirect_url;
          } else {
            // Fallback: manually navigate to the next page
            navigate(next);
          }
        } else {
          console.error("Token login failed:", response.data);
          navigate("/login?error=token_login_failed");
        }
      } catch (error) {
        console.error("Token login failed:", error);

        // Handle specific error cases
        if (error.response?.status === 401) {
          navigate("/login?error=expired_or_invalid");
        } else if (error.response?.status === 404) {
          navigate("/login?error=invalid_token");
        } else if (error.response?.status >= 500) {
          navigate("/login?error=server_error");
        } else {
          navigate("/login?error=network");
        }
      } finally {
        setIsLoading(false);
      }
    };

    loginViaToken();
  }, [token, next, navigate, setIsAuthenticated, checkAuth]);

  if (isLoading) {
    return <LoadingOverlay message="Logging you in..." />;
  }

  // This should rarely be seen as we navigate away or show loading
  return (
    <div
      style={{
        padding: "100px",
        textAlign: "center",
        minHeight: "50vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <h2 style={{ color: "#333", marginBottom: "16px" }}>
        Processing login...
      </h2>
      <p style={{ color: "#666", marginBottom: "24px", maxWidth: "400px" }}>
        If you are not redirected automatically, please check your connection
        and try again.
      </p>
      <button
        onClick={() => navigate("/login")}
        style={{
          padding: "12px 24px",
          backgroundColor: "#FF67A1",
          color: "white",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: "500",
        }}
      >
        Go to Login Page
      </button>
    </div>
  );
};

export default TokenLoginPage;
